import React from "react";
import { Routes, Route } from "react-router-dom";
import './css/Colores.css';
import Formulario from "./Dashboard/Formulario";
import Dashboard from "./Dashboard";
import Inicio from "./Pages/Inicio";
import Usuarios from "./Pages/Usuarios";
import Clientes from "./Pages/Clientes";
import Empresas from "./Pages/Empresas";
import Eventos from "./Pages/Eventos";
import Cupones from "./Pages/Cupones";
import Tarjetas from "./Pages/Tarjetas";
import Promociones from "./Pages/Promociones";
import EditarUsuario from "./Usuarios/EditarUsuario";
import AgregarEmpresa from "./Empresas/AgregarEmpresa";
import EditarEmpresa from "./Empresas/EditarEmpresa";
import EditarEventos from "./Eventos/EditarEventos";
import AltaEventos from "./Eventos/AltaEventos";
import EditarCupones from "./Cupones/EditarCupones";
import AgregarTarjeta from "./Tarjetas/AgregarTarjeta";
import EditarTarjeta from "./Tarjetas/EditarTarjeta";
import ImportarTarjetas from "./Tarjetas/ImportarTarjetas";
import EditarPromociones from "./Promociones/EditarPromociones";
import AgregarPromociones from "./Promociones/AgregarPromociones";
import NuevaPromocion from "./Promociones/NuevaPromocion";
import { ToastProvider } from "./contexts/ToastContext";
import Toast from "./Components/Toast";

function App() {
  return (
    <ToastProvider>
      <Routes>

        {/* Página de Login */}
        <Route path="/" element={<Formulario />} />

        {/* Layout con el menú fijo */}
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="inicio" element={<Inicio />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="empresas" element={<Empresas />} />
          <Route path="eventos" element={<Eventos />} />
          <Route path="cupones" element={<Cupones />} />
          <Route path="tarjetas" element={<Tarjetas />} />
          <Route path="promociones" element={<Promociones />} />
          <Route path="usuarios/editarusuario" element={<EditarUsuario />} />
          <Route path="empresas/agregarempresa" element={<AgregarEmpresa />} />
          <Route path="empresas/editarEmpresa/:id" element={<EditarEmpresa />} />
          <Route path="eventos/editareventos" element={<EditarEventos />} />
          <Route path="eventos/editareventos/:idEvento" element={<EditarEventos />} />
          <Route path="eventos/alta-eventos" element={<AltaEventos />} />
          <Route path="cupones/editarcupones" element={<EditarCupones />} />
          <Route path="cupones/editarcupones/:id" element={<EditarCupones />} />
          <Route path="tarjetas/agregartarjeta" element={<AgregarTarjeta />} />
          <Route path="tarjetas/editartarjeta/:numeroTarjeta" element={<EditarTarjeta />} />
          <Route path="tarjetas/importar" element={<ImportarTarjetas />} />
          <Route path="promociones/editarpromociones" element={<EditarPromociones />} />
          <Route path="promociones/editarpromociones/:id" element={<EditarPromociones />} />
          <Route path="promociones/nuevapromocion" element={<AgregarPromociones />} />
          <Route path="clientes/editarcliente/:id" element={<div>Editar Cliente - Por implementar</div>} />


        </Route>

      </Routes>
      <Toast />
    </ToastProvider>
  );
}

export default App;
